import _classPrivateFieldGet from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
import Cookies from 'universal-cookie';
const SECONDS_IN_DAY = 86400;
var _cookieManager = /*#__PURE__*/new WeakMap();
var _cookieName = /*#__PURE__*/new WeakMap();
var _expiryInDays = /*#__PURE__*/new WeakMap();
var _expiryInSeconds = /*#__PURE__*/new WeakSet();
export class CookieSessionIdStorage {
  constructor(_ref) {
    let {
      cookieManager = new Cookies(),
      cookieName,
      expiryInDays
    } = _ref;
    _classPrivateMethodInitSpec(this, _expiryInSeconds);
    _classPrivateFieldInitSpec(this, _cookieManager, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _cookieName, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _expiryInDays, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _cookieManager, cookieManager);
    _classPrivateFieldSet(this, _cookieName, cookieName);
    _classPrivateFieldSet(this, _expiryInDays, expiryInDays);
  }
  getSessionId(options) {
    const sessionId = _classPrivateFieldGet(this, _cookieManager).get(_classPrivateFieldGet(this, _cookieName));
    if (options !== null && options !== void 0 && options.extendSession && sessionId) {
      this.setSessionId(sessionId);
    }
    return sessionId;
  }
  setSessionId(sessionId) {
    _classPrivateFieldGet(this, _cookieManager).set(_classPrivateFieldGet(this, _cookieName), sessionId, {
      path: '/',
      sameSite: 'strict',
      maxAge: _classPrivateMethodGet(this, _expiryInSeconds, _expiryInSeconds2).call(this)
    });
  }
  clearSessionId() {
    _classPrivateFieldGet(this, _cookieManager).remove(_classPrivateFieldGet(this, _cookieName));
  }
}
function _expiryInSeconds2() {
  if (!_classPrivateFieldGet(this, _expiryInDays)) {
    return undefined;
  }
  return _classPrivateFieldGet(this, _expiryInDays) * SECONDS_IN_DAY;
}